var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filled",
    stroke: "none",
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tech_sliced",
    transform: "translate(-840.000000, 0.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Tech",
    transform: "translate(-838.000000, 7.000000)",
    strokeLinecap: "round",
    stroke: "#535353",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Browsercode",
    transform: "translate(840.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-435",
    x: 0,
    y: 8,
    width: 56,
    height: 38
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-436",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 56,
    height: 8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-475",
    cx: 4,
    cy: 4,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-476",
    cx: 9,
    cy: 4,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-477",
    cx: 14,
    cy: 4,
    r: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-459",
    x: 7,
    y: 14,
    width: 8,
    height: 11,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-459",
    x: 29.0018986,
    y: 14,
    width: 8,
    height: 11,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-459",
    x: 36.0037973,
    y: 29.992017,
    width: 8,
    height: 11,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-459",
    x: 7,
    y: 29.992017,
    width: 8,
    height: 11,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0018986,14 C22.1054196,14 23,14.9001762 23,15.992017 L23,25.007983",
    id: "Rectangle-459"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0037973,29.992017 C29.1073182,29.992017 30.0018986,30.8921932 30.0018986,31.984034 L30.0018986,41",
    id: "Rectangle-459"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0018986,29.992017 C22.1054196,29.992017 23,30.8921932 23,31.984034 L23,41",
    id: "Rectangle-459"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0037973,14 C44.1073182,14 45.0018986,14.9001762 45.0018986,15.992017 L45.0018986,25.007983",
    id: "Rectangle-459"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bd96c393.svg";
export { ForwardRef as ReactComponent };